import { render } from "./TreeRow.vue?vue&type=template&id=f2d82504&scoped=true"
import script from "./TreeRow.vue?vue&type=script&lang=ts"
export * from "./TreeRow.vue?vue&type=script&lang=ts"

import "./TreeRow.vue?vue&type=style&index=0&id=f2d82504&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f2d82504"

export default script